module.exports = __webpack_public_path__ + "img/9788958074113.2c5fa444.jpg";